export const GET_USER_LOCATIONS = 'GET_USER_LOCATIONS'
export const GET_SELECTED_ADDRESS = 'GET_SELECTED_ADDRESS'
export const GET_PUBLIC_COORDINATES = 'GET_PUBLIC_COORDINATES'
export const GET_USER_COORDINATES = 'GET_USER_COORDINATES'
export const ADD_PUBLIC_MAP_LOCATION = 'ADD_PUBLIC_MAP_LOCATION'
export const SET_PUBLIC_VIEWPORT = 'SET_PUBLIC_VIEWPORT'
export const SET_TRIGGER_REGISTRATION_BUTTON = 'SET_TRIGGER_REGISTRATION_BUTTON'
export const SET_ALL_FIRES = 'SET_ALL_FIRES'
export const SET_LOCAL_FIRES = 'SET_LOCAL_FIRES' //Doesn't appear anywhere else
export const SET_SELECTED_MARKER = 'SET_SELECTED_MARKER'
export const DELETE_LOCATION_MARKER = 'DELETE_LOCATION_MARKER'
export const SET_SAVED_LOCATION = 'SET_SAVED_LOCATION'
export const SET_USER_LOCATIONS = 'SET_USER_LOCATIONS'
export const TOGGLE_NOTIFICATIONS = 'TOGGLE_NOTIFICATIONS'
export const DELETE_USER_LOCATION = 'DELETE_USER_LOCATION'
export const SET_EXCLAMATION_MARKERS = 'SET_EXCLAMATION_MARKERS'
export const SET_SAVED_LOCATION_ERROR = 'SET_SAVED_LOCATION_ERROR'
